<template>
  <div class="leave-template">
    <ListingTemplate :customClass="'leave-listing'">
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template>
              <v-col cols="4" class="py-0 float-start d-flex justify-flex-start">
                <v-text-field v-model.trim="filter_search" v-on:click:clear="clearFilter('search')" clearable dense
                  filled flat label="Type and press enter to search" hide-details style="max-width: 300px" solo
                  :loading="pageLoading" :disabled="pageLoading" color="cyan" append-icon="mdi-magnify"
                  @keydown.enter="leaveFilter" @keydown.tab="leaveFilter" v-on:change="leaveFilter"></v-text-field>
              </v-col>
              <v-col cols="4" class="py-0 float-end d-flex justify-flex-end">
                <v-btn depressed :disabled="dataLoading" color="#24326d" class="mx-1 custom-bold-button white--text"
                  @click="create_leave_dialog = true">
                  <v-icon dark left>mdi-plus</v-icon> Create
                </v-btn>
                <v-btn depressed :disabled="dataLoading" class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text" v-on:click="searchDialog = true">
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
                <v-menu max-height="400" max-width="250" offset-y left :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed :disabled="dataLoading" class="mx-2 custom-bold-button" color="cyan white--text"
                      v-bind="attrs" v-on="on">
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable tag="ul" v-model="defaultColDefs" v-on:change="updateVisible()" class="draggable-group"
                    handle=".draggable-drag-icon">
                    <template v-for="cols in defaultColDefs">
                      <li class="draggable-group-item" :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0">
                        <v-checkbox dense v-model="defaultColShow" v-bind:value="cols.field" :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading" color="cyan" v-on:change="updateVisible()"
                          hide-details class="pt-2 mt-0"></v-checkbox>
                        <v-icon class="draggable-drag-icon" small right color="cyan">mdi-drag</v-icon>
                      </li>
                    </template>
                  </draggable>
                </v-menu>
              </v-col>
            </template>
          </template>
        </ListingHeader>
        <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow"
          style="height: calc(100vh - 120px); position: relative">
          <LeaveListing @status-dialog="
            (statusDialog = $event),
            ((visits = []),
              (rejected_remark = null),
              (cancelled_remark = null))
            " @status-data="statusdata = $event" @leave-details="leaveDetails" :autoRefresh="autoRefresh">
          </LeaveListing>
        </perfect-scrollbar>
      </template>
    </ListingTemplate>

    <template v-if="create_leave_dialog">
      <CreateLeave :drawer="create_leave_dialog" :leaveUpdateData="leaveCreate" @close="
        leaveCreate = {};
      create_leave_dialog = false;
      "></CreateLeave>
    </template>
    <Dialog v-if="statusDialog" :common-dialog="statusDialog" :dialog-width="640" isClass>
      <template v-slot:title>
        <div class="d-flex">Confirmed</div>
      </template>
      <template v-slot:body>
        <v-form v-model="formValid">
          <v-row class="delete-dialog">
            <v-col md="12" class="py-0 my-auto py-2">
              <div class="btx-div m-0" v-if="statusdata == 'delete'">
                <span class="font-weight-600">
                  <span style="font-size: 18px !important">
                    Are you sure, You want to Delete this Leave</span>

                  <v-chip outlined label color="teal" class="ml-2"><span class="font-weight-600">{{
                    leaveBarcode
                      }}</span> </v-chip>&nbsp;?
                </span>
              </div>
              <div v-if="statusdata == 'rejected'">
                <span class="font-weight-600">
                  <span style="font-size: 19px !important">
                    Are you sure, You want to Reject this Leave
                  </span>

                  <v-chip outlined label color="red" class="ml-2">
                    <span class="font-weight-600">{{
                      leaveBarcode
                    }}</span> </v-chip>&nbsp; ?
                </span>

                <div class="mt-3" v-if="statusdata == 'rejected'">
                  <label class="input-label required mb-1">Reject Remark</label>
                  <v-textarea auto-grow dense :rules="[validateRules.required(rejected_remark, 'Remark')]" filled
                    color="cyan" v-model="rejected_remark" placeholder="Reason for leave" solo flat
                    row-height="15"></v-textarea>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn class="mx-2 custom-grey-border custom-bold-button white--text" color="red" :disabled="!formValid"
          @click="dropData(visits.visitId)" style="min-width: 78px !important">
          Delete
        </v-btn>
        <v-btn class="mx-2 custom-grey-border custom-bold-button" @click="statusDialog = false">
          Close
        </v-btn>
      </template>
    </Dialog>

    <Dialog :commonDialog="searchDialog">
      <template v-slot:title>Filter Leaves</template>
      <template v-slot:body>
        <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow"
          style="position: relative">
          <v-container fluid class="pt-0 custom-search-filter">
            <v-row>

              <v-col md="6">
                <v-text-field v-model.trim="barcode" v-on:click:clear="clearFilter('barcode')" clearable dense filled
                  flat label="Leave #" hide-details solo :loading="pageLoading" :disabled="pageLoading"
                  color="cyan"></v-text-field>
              </v-col>
              <v-col md="6">
                <v-autocomplete :items="userList" v-model="filter_user" dense flat clearable filled label="Staff"
                  item-color="cyan" v-on:click:clear="clearFilter('user')" color="cyan" solo :disabled="pageLoading"
                  item-value="id" item-text="display_name" class="filter-select" />
              </v-col>
              <v-col md="6">
                <v-autocomplete :items="leaveCategory" v-model="filter_category" dense flat clearable filled
                  label="Category" item-color="cyan" v-on:click:clear="clearFilter('user')" color="cyan" solo
                  :disabled="pageLoading" item-value="name" item-text="name" class="filter-select" />
              </v-col>
              <v-col md="6">
                <DateRangePicker placeholder="Data Range" v-model="dates" v-on:click:clear="clearFilter('dates')"
                  class="mr-2"></DateRangePicker>
              </v-col>
            </v-row>
          </v-container>
        </perfect-scrollbar>
      </template>
      <template v-slot:action>
        <v-btn depressed :disabled="dataLoading" class="mx-2 custom-grey-border custom-bold-button"
          color="cyan white--text" v-on:click="
            () => {
              leaveFilter(7);
              searchDialog = false;
            }
          ">
          Filter
        </v-btn>
        <v-btn depressed :disabled="dataLoading" class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="searchDialog = false">
          Close
        </v-btn>
      </template>
    </Dialog>
    <VCard border class="pr-3 py-0 filter-enabled main-listing-page" v-if="isFilterApply() && !searchDialog">
      <div class="d-flex">
        <div class="d-flex">
          <div class="mr-1 px-2 font-weight-medium text-uppercase text-center" style="
              font-size: 15px;
              border-right: 1px solid #f7e3cd;
              background-color: #f7e3cd;
            ">
            Filtered<br />
            By
          </div>
          <div>
            <template v-if="filter_search">
              <VChip label class="ma-1" close @click:close="() => removeFilters('search')">{{ filter_search }}
              </VChip>
            </template>
            <template v-if="filter_user">
              <VChip label class="ma-1" close @click:close="() => removeFilters('user')">Staff : {{ g_filter_user() }}
              </VChip>
            </template>
            <template v-if="barcode">
              <VChip label class="ma-1" close @click:close="() => removeFilters('barcode')">Leave # : {{ barcode }}
              </VChip>
            </template>
            <template v-if="filter_category">
              <VChip label class="ma-1" close @click:close="() => removeFilters('category')">Category : {{
                g_filter_category() }}</VChip>
            </template>
            <template v-if="dates?.length >0">
              <VChip label class="ma-1" close @click:close="() => removeFilters('dates')">Date Range: {{
                dates[0] }} - {{ dates[1] }}</VChip>
            </template>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="red" size="small" v-bind="attrs" v-on="on" @click="removeFilters('all')">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Remove All Filters</span>
        </v-tooltip>
      </div>
    </VCard>
  </div>
</template>

<style>
.filter-enabled {
  background-color: #fdf0d1 !important;
  position: fixed;
  bottom: 10px;
  left: 50%;
  max-width: 768px;
  min-width: 480px;
  transform: translateX(-50%);
  z-index: 9;
}
</style>
<script>
import draggable from "vuedraggable";
import ListingMixin from "@/core/plugins/listing-mixin";

import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET, PATCH, DELETE, POST } from "@/core/services/store/request.module";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import { LeaveApplyEventBus } from "@/core/lib/leave.from.lib.js";
import { mapGetters } from "vuex";
import {
  SET_FILTER,
  RESET_STATE,
} from "@/core/services/store/leave.module";
import { SearchEventBus } from "@/core/lib/search.lib";
import Dialog from "@/view/pages/partials/Dialog";
import CreateLeave from "@/view/pages/leave/Create-Or-Update/CreateLeave";
import LeaveListing from "@/view/pages/leave/LeaveListing";
import DateRangePicker from "@/view/components/DateRangePicker.vue";

export default {
  mixins: [CommonMixin, ValidationMixin, ListingMixin],
  name: "leave-list",
  data() {
    return {
      create_leave_dialog: false,
      leaveBarcode: null,
      leaveId: null,
      exportLoading: false,
      statusdata: null,
      dataLoading: false,
      leaveCreate: null,
      pageModule: "leave-listing",
      routeAPI: "leave",
      routeName: "leave",
      routeDetailName: "leave.detail",
      status: "all",
      queryParams: {},
      searchDialog: false,
      box: false,
      leaveCategory: [],
      defaultColDefs: [],
      userList: [],
      dates: [],
      filter_category: null,
      barcode: null,
      status_filter: "all",
      filter_user: 0,
      filter_search: null,
      visits: [],
      autoRefresh: false,
      pageLoading: false,
      selectedRows: [],
      formValid: true,
      statusList: [],
      rejected_remark: null,
      cancelled_remark: null,
      statusDialog: false,
      moreActions: [
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      rows_selected: [],
      searchableArray: [
        "barcode",
        "display_name",
        "category",
        "reason",
        "status",
      ],
    };
  },
  watch: {},
  components: {
    draggable,
    ListingTemplate,
    ListingHeader,
    Dialog,
    CreateLeave,
    LeaveListing,
    DateRangePicker,
  },
  methods: {
    getLeaveDays() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "leave/options",
        })
        .then(({ data }) => {
          _this.userList = data.users;
          _this.leaveCategory = data.leave_type;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    updateVisible() {
      const _this = this;
      for (let index = 0; index < _this.defaultColDefs.length; index++) {
        const element = _this.defaultColDefs[index];
        _this.defaultColDefs[index].visible = 0;
        if (_this.defaultColShow.includes(element.field)) {
          _this.defaultColDefs[index].visible = 1;
        }
      }

      _this.$nextTick(() => {
        _this.$store
          .dispatch(POST, {
            url: "group",
            data: { tables: this.defaultColDefs },
          })
          .then(({ data }) => {
            this.customThead = data;
            LeaveApplyEventBus.$emit("refresh-headers", data);
          });
      });
    },
    leaveDetails(event) {
      this.leaveBarcode = event.barcode;
      this.leaveId = [event.leaveId];
    },
    clearFilter(type) {
      if (type == "dates") {
        this.dates = [];
      } else if (type == "category") {
        this.filter_category = null;
      } else if (type == "barcode") {
        this.barcode = null;
      } else if (type == "user") {
        this.filter_user = null;
      } else if (type == "search") {
        this.filter_search = null;
      }
      this.leaveFilter(6);
    },
    clearSelections() {
      this.selectedRows = [];
    },
    dropData() {
      this.autoRefresh = false;
      this.pageLoading = true;
      this.$store
        .dispatch(PATCH, {
          url: `leave/delete/${this.leaveId}`,
          data: { data: this.leaveId },
        })
        .then(() => {
          this.statusDialog = false;
          this.detailDialog = false;
          this.autoRefresh = true;
          LeaveApplyEventBus.$emit("refresh");
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    leaveFilter(test) {
      console.log({ test });
      let _this = this;
      let leaveFilter = {
        daterange: _this.dates,
        search: _this.lodash.toString(_this.filter_search) || null,
        user: _this.lodash.toSafeInteger(_this.filter_user) || null,
        category: _this.lodash.toString(_this.filter_category) || null,
        barcode: _this.lodash.toString(_this.barcode) || null,
        status: _this.lodash.toString(_this.status_filter) || null,
      };
      _this.$store.dispatch(SET_FILTER, leaveFilter);
    },
    deleteLeave() {
      const _this = this;
      _this.$store
        .dispatch(DELETE, {
          url: "leave/" + _this.leaveId,
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    isFilterApply() {
      let isFilter = false;
      if (
        this.filter_search ||
        this.filter_user ||
        this.filter_category ||
        this.barcode ||
        this.dates?.length
      ) {
        isFilter = true;
      }
      return isFilter;
    },
    g_filter_user() {
      const user = this.userList?.find((row) => row.id === this.filter_user);
      return user?.display_name;
    },
    g_filter_category() {
      const category = this.leaveCategory?.find(
        (row) => row.name === this.filter_category
      );
      console.log("category", category);

      return category?.name || this.filter_category;
    },
    removeFilters(type) {
      if (type === "all") {
        this.filter_search = null;
        this.filter_user = null;
        this.filter_category = null;
        this.barcode = null;
        this.dates = [];
      } else if (type === "search") {
        this.filter_search = null;
      } else if (type === "user") {
        this.filter_user = null;
      } else if (type === "category") {
        this.filter_category = null;
      } else if (type === "barcode") {
        this.barcode = null;
      } else if (type === "dates") {
        this.dates = [];
      }
      this.leaveFilter(9);
    },
  },

  computed: {
    ...mapGetters(["getLeaveStatus"]),
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);
    _this.status = _this.$route.query.status || _this.status;
    _this.status_filter = _this.status;
    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 10;

    _this.leaveFilter(8);
  },
  mounted() {
    this.getLeaveDays();
    SearchEventBus.$emit("search-template", false);
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Leave",
      },
    ]);
    LeaveApplyEventBus.$on("refresh", () => {
      this.autoRefresh = true;
      setTimeout(() => {
        this.autoRefresh = false;
      }, 1000);
    });
  },
  beforeDestroy() {
    SearchEventBus.$emit("search-template", false);
    this.$store.dispatch(RESET_STATE);
    LeaveApplyEventBus.$off("refresh");
  },
};
</script>
